import { ExportIntegrationStatus, ExportItem } from '@aibees/elephant/hooks';
import { PopoverListButtonItem } from '@aibees/shared/components';
import { ExportStatus } from '@aibees/shared/components/status-tag';
import { Avatar } from '@mui/material';
import { ExportTableActionType as Action } from './types';

export const getExportActionMenuItemsOptions = (item: ExportItem) => {
  const integrationFailed =
    item.integrations?.SMART_LEAD?.status === ExportIntegrationStatus.FAILED;
  const showRetry = item.status === ExportStatus.FAILED || integrationFailed;

  return [
    { label: 'Edit Name', key: Action.edit, icon: 'edit-outline' },
    ...(showRetry
      ? [{ label: 'Retry', key: Action.retry, icon: 'reload' }]
      : []),
    { label: 'Copy ID', key: Action.copyID, icon: 'copy' },
    { label: 'Search Link', key: Action.searchLink, icon: 'search' },
    ...(item.integrations
      ? [
          {
            label: 'View Campaign',
            key: Action.viewCampaign,
            icon: <Avatar src="/assets/images/Smartlead.jpg" size={16} />,
          },
        ]
      : []),
    ...(integrationFailed
      ? [
          {
            label: 'Download CSV',
            key: Action.downloadCSV,
            icon: 'file-csv-outline',
          },
        ]
      : []),
  ] as PopoverListButtonItem[];
};
